// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".coupon-codes[data-v-714120cf]{border:2px dotted red}", "",{"version":3,"sources":["webpack://./resources/assets/frontend/js/components/booking/CouponCodes.vue"],"names":[],"mappings":"AAEA,+BACI,qBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
